var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c(_setup.Treeselect,{staticClass:"w-full",attrs:{"value":_setup.currentValue,"disable-branch-nodes":true,"multiple":_vm.multiple,"normalizer":_setup.normalizer,"options":_vm.options,"disable-fuzzy-matching":""},on:{"input":_setup.onInput}})
}
var staticRenderFns = []

export { render, staticRenderFns }